import { render } from "./SetPasswordCard.vue?vue&type=template&id=3706a6b4"
import script from "./SetPasswordCard.vue?vue&type=script&lang=js"
export * from "./SetPasswordCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__